<template>
  <div class="mortgage-progress-edit-item-component" v-bind:class="{loading}">
    <a-row type="flex">
      <a-col flex="auto">
        <div>{{ mortgageProgress.name }}</div>
        <div class="small" v-if="false">
          <check-bold-icon class="green" v-if="mortgageProgress.received" />
          <close-thick-icon class="red" v-else />
          Opgevraagd bij klant

          <check-bold-icon class="green" v-if="mortgageProgress.sent" />
          <close-thick-icon class="red" v-else />
          Verzonden naar maatschappij

          <check-bold-icon class="green" v-if="mortgageProgress.completed" />
          <close-thick-icon class="red" v-else />
          Goedgekeurd
        </div>
      </a-col>
      <a-col flex="100px" class="text-right">
        <a-popconfirm
          :disabled="!isEditable"
          :title="deleteConfirmTitle"
          :visible="deleteConfirmVisible"
          ok-text="Ja"
          cancel-text="Nee"
          @visibleChange="handleVisibleChange"
          @confirm="onDeleteConfirm">
          <a-button type="danger" :class="`delete-button ${!isEditable ? 'disabled' : ''}`" :loading="loading"
                    :disabled="!isEditable">
            <close-thick-icon />
          </a-button>
        </a-popconfirm>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: "MortgageProgressEditItemComponent",
  components: {},
  props: {
    mortgageProgress: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      deleteConfirmVisible: false,
      loading: false
    };
  },
  mounted() {

  },
  computed: {
    isEditable() {
      return !(this.mortgageProgress.sent || this.mortgageProgress.received || this.mortgageProgress.completed);
    },
    shouldConfirm() {
      return this.mortgageProgress.received
        || this.mortgageProgress.sent
        || this.mortgageProgress.completed;
    },
    deleteConfirmTitle() {
      let action = "";

      if (
        this.mortgageProgress.received === true
        && this.mortgageProgress.sent === false
        && this.mortgageProgress.completed === false
      ) {
        action = "ontvangen van de klant";
      } else if (
        this.mortgageProgress.received === true
        && this.mortgageProgress.sent === true
        && this.mortgageProgress.completed === false
      ) {
        action = "verzonden naar de maatschappij";
      } else if (
        this.mortgageProgress.received === true
        && this.mortgageProgress.sent === true
        && this.mortgageProgress.completed === true
      ) {
        action = "goedgekeurd door de maatschappij";
      }

      return `Weet je het zeker? Dit document is namelijk al ${action}.`;
    }
  },
  methods: {
    onDeleteConfirm() {
      this.loading = true;
      this.$emit("delete", this.mortgageProgress);
    },
    handleVisibleChange(visible) {
      if (!visible) {
        this.deleteConfirmVisible = false;
        return;
      }

      if (this.shouldConfirm) {
        this.deleteConfirmVisible = true;
      } else {
        this.onDeleteConfirm();
      }
    }
  }
};
</script>
<style scoped>
.mortgage-progress-edit-item-component {
  position: relative;
  border: solid 1px #e8e8e8;
  border-radius: 4px;
  box-shadow: 0 0 5px -4px rgba(0, 0, 0, 0.4);
  padding: 10px;
  margin-bottom: 5px;
}

.mortgage-progress-edit-item-component.loading {
  background: #ededed;
  opacity: 0.6;
  cursor: progress;
}

.mortgage-progress-edit-item-component .delete-button {
  margin: -5px;
}

.mortgage-progress-edit-item-component .delete-button .disabled {
  margin-right: 0;
  margin-top: 0;
}

.mortgage-progress-edit-item-component .small {
  color: #333;
}

.mortgage-progress-edit-item-component .small .green {
  color: green;
}

.mortgage-progress-edit-item-component .small .red {
  color: #870000;
}
</style>
